/**
 * @Name 资源配置路由配置区
 */
const resourcesConfig = () => import('@/views/resources_config/index.vue')
const ExhiConfig = () => import('@/views/resources_config/exhiConfig/index.vue')
const ExhiInfo = () => import('@/views/resources_config/exhiConfig/addExhi.vue')
const ExhiDetail = () => import('@/views/resources_config/exhiConfig/exhiDetail.vue')
const UserPermissionConfig = () => import('@/views/resources_config/user_permission_config/index.vue')
const AddUserPermission = () => import('@/views/resources_config/user_permission_config/AddUserRole.vue')
export default [
    {
        path: 'registManage',
        name: 'registManage',
        component: () => import('@/views/registManage/index.vue'),
        meta: { exhiHome: true, overvisable: true, menuName: 'registManage', noPadding: true },
        children: [
            {
                path: 'todoList',
                name: 'todoList',
                component: () => import('@/views/registManage/todoList.vue'),
                meta: { exhiHome: false, greyBack: true, menuName: 'registManage' }
            },
            {
                path: 'approveDetail',
                name: 'approveDetail',
                component: () => import('@/views/registManage/approveDetail.vue'),
                meta: { exhiHome: false, greyBack: true, menuName: 'registManage', minPage: true }
            },
            {
                path: 'seatConfig',
                name: 'seatConfig',
                component: () => import('@/views/registManage/seatConfig.vue'),
                meta: { exhiHome: false, greyBack: true, menuName: 'registManage' }
            },
            {
                path: 'guestManage',
                name: 'guestManage',
                component: () => import('@/views/registManage/guestManage.vue'),
                meta: { exhiHome: false, greyBack: true, menuName: 'registManage' }
            },
            {
                path: 'staffManage',
                name: 'staffManage',
                component: () => import('@/views/registManage/staffManage.vue'),
                meta: { exhiHome: false, greyBack: true, menuName: 'registManage' }
            }
        ]
    },
    {
        path: 'w3EmpApprove',
        name: 'w3EmpApprove',
        component: () => import('@/views/w3/w3EmpApprove.vue'),
        meta: { w3Approve: true, noPadding: true, greyBack: true }
    },
    {
        path: 'config',
        name: 'config',
        component: resourcesConfig,
        children: [
            {
                path: 'switchConfig', // 开关配置
                name: 'switchConfig',
                component: () => import('@/views/resources_config/resource_switch/index.vue'),
                meta: {
                    pass: true,
                    prem: ''
                }
            },
            {
                path: 'exhiConfig/:params?',
                name: 'exhiConfig',
                component: ExhiConfig,
                meta: {
                    prem: 'SYS-EXHIBIT-MANAGE'
                }
            },
            {
                path: 'exhiInfo',
                name: 'exhiInfo',
                component: ExhiInfo,
                meta: {
                    prem: 'SYS-EXHIBIT-MANAGE'
                }
            },
            {
                path: 'exhiDetail',
                name: 'exhiDetail',
                component: ExhiDetail,
                meta: {
                    prem: 'SYS-EXHIBIT-MANAGE'
                }
            },
            {
                path: 'registResourceConfig', // 报名资源配置
                name: 'registResourceConfig',
                component: () => import('@/views/resources_config/registManage/registResourceConfig/index.vue'),
                meta: {
                    pass: true,
                    prem: ''
                }
            },
            {
                path: 'registList', // 报名注册列表
                name: 'registList',
                component: () => import('@/views/resources_config/registManage/registList/index.vue'),
                meta: {
                    pass: true,
                    prem: ''
                }
            },
            {
                path: 'blacklistManage', // 报名注册列表
                name: 'blacklistManage',
                component: () => import('@/views/resources_config/blacklistManage/index.vue'),
                meta: {
                    pass: true,
                    prem: ''
                }
            },
            {
                path: 'agendaManage', // 议程资料管理
                name: 'agendaManage',
                component: () => import('@/views/resources_config/agendaManage/index.vue'),
                meta: {
                    pass: true,
                    prem: ''
                }
            },
            {
                // 用户权限配置
                path: 'userPermissionConfig/:param?',
                name: 'userPermissionConfig',
                component: UserPermissionConfig,
                meta: {
                    prem: 'SYS-EXHIBIT-MANAGE'
                }
            },
            {
                // 新增用户权限
                path: 'addUserPermission/:param?',
                name: 'addUserPermission',
                component: AddUserPermission,
                meta: {
                    prem: 'SYS-EXHIBIT-MANAGE'
                }
            }
        ]
    }
]
